<template>
  <div class="category-one-content">
    <div class="delivery-grid">
      <v-card class="delivery-card" elevation="1">
        <div class="card-header">
          <div class="icon-badge">
            <v-icon size="24" color="white">mdi-postage-stamp</v-icon>
          </div>
          <div>
            <h2>{{ t('rechnung.categoryOne.postTitle') }}</h2>
            <p>{{ t('rechnung.categoryOne.postSubtitle') }}</p>
          </div>
        </div>
        <div class="card-body">
          <div v-if="tarif" class="address-block" v-html="tarif.un_rechnung"></div>
          <p v-else class="placeholder-text">
            {{ t('rechnung.categoryOne.loadingAddress') }}
          </p>

          <div class="card-links">
            <v-btn
              v-if="pdfUrlRechnung"
              :href="pdfUrlRechnung"
              target="_blank"
              color="#EA5545"
              variant="flat"
              prepend-icon="mdi-file-download"
            >
              {{ t('rechnung.categoryOne.pdfRechnung') }}
            </v-btn>
            <v-btn
              v-if="pdfUrlHeilkostenplan"
              :href="pdfUrlHeilkostenplan"
              target="_blank"
              color="#EA5545"
              variant="outlined"
              prepend-icon="mdi-file-download"
            >
              {{ t('rechnung.categoryOne.pdfHeilkostenplan') }}
            </v-btn>
          </div>
        </div>
      </v-card>

      <v-card class="delivery-card" elevation="1">
        <div class="card-header">
          <div class="icon-badge email">
            <v-icon size="24" color="white">mdi-email-fast</v-icon>
          </div>
          <div>
            <h2>{{ t('rechnung.categoryOne.emailTitle') }}</h2>
            <p>{{ t('rechnung.categoryOne.emailSubtitle') }}</p>
          </div>
        </div>

        <div class="card-body">
          <div class="mail-address" v-if="tarif">
            <v-icon size="18" color="#EA5545" class="mr-2">mdi-email-outline</v-icon>
            {{ tarif.un_rechnung_email }}
          </div>
          <p v-else class="placeholder-text">
            {{ t('rechnung.categoryOne.loadingEmail') }}
          </p>

          <div class="card-links mail-links">
            <v-btn
              v-if="emailHrefRechnung"
              :href="emailHrefRechnung"
              color="#EA5545"
              variant="flat"
              prepend-icon="mdi-send"
            >
              {{ t('rechnung.categoryOne.emailSendRechnung') }}
            </v-btn>
            <v-btn
              v-if="emailHrefHeilkostenplan"
              :href="emailHrefHeilkostenplan"
              color="#EA5545"
              variant="outlined"
              prepend-icon="mdi-send"
            >
              {{ t('rechnung.categoryOne.emailSendHeilkostenplan') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>

    <v-card class="tips-card" elevation="1">
      <div class="card-header tips-header">
        <div class="icon-badge tips">
          <v-icon size="24" color="white">mdi-lightbulb-on</v-icon>
        </div>
        <div>
          <h2>{{ t('rechnung.categoryOne.tipsTitle') }}</h2>
          <p>{{ t('rechnung.categoryOne.tipsSubtitle') }}</p>
        </div>
      </div>

      <ol class="tips-list">
        <li v-for="(tip, index) in t('rechnung.categoryOne.tips')" :key="index">
          {{ t(`rechnung.categoryOne.tips.${index}`, { projectName }) }}
        </li>
      </ol>
    </v-card>
  </div>
</template>

<script setup>
import { useLanguage } from '@/composables/useLanguage'

/* global defineProps */

const { t } = useLanguage()

defineProps({
  tarif: {
    type: Object,
    default: null
  },
  pdfUrlRechnung: {
    type: String,
    default: null
  },
  pdfUrlHeilkostenplan: {
    type: String,
    default: null
  },
  emailHrefRechnung: {
    type: String,
    default: null
  },
  emailHrefHeilkostenplan: {
    type: String,
    default: null
  },
  projectName: {
    type: String,
    default: 'Clearment'
  }
})
</script>

<style scoped src="@/assets/styles/sfc/components/objects/RechnungCategoryOne.css"></style>
